// import keycloak from "../../../keycloak.js";
// import { jwtDecode } from "jwt-decode";

// interface JwtPayload {
//   sub: string;
//   name?: string;
//   exp?: number;
//   [key: string]: any;
// }

import '@ant-design/v5-patch-for-react-19';
import { useState, useEffect } from "react";
import { Modal, Form, Spin, Card, Row, Col, Input, Button, Select, Tooltip, DatePicker } from "antd";

// import { useNavigate } from "react-router-dom";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";

import { carregaCEP, carregaListaMunicipios, carregaListaNaturezasJuridicasIbge, carregaListaPaises, carregaListaUF, consultaCNPJReceita } from "../services";
import { maskCep, maskCnpj, maskNumeroProcesso, maskTelefone, numberOnly } from "../../../utils/maskFunctions";
import { color, resetColor } from "../../../utils/utilsFunctions";

import api from "../../../services/api";
import { type IErroApi } from "../../../services/api";
import type { IPessoaJuridica, ISelectList } from "../../../components/Interfaces";

import { errorMessage, mostrarInfoDetail, successMessage } from '../../../messages/messages';

import { useLocation } from "react-router";

const { info } = Modal;

import dayjs from "dayjs";
import CadInfoBotoes from '../../../components/CadInfoBotoes';

const Manter = () => {

  // const token = keycloak.token;
  //console.log(token);

  // function decodeToken(token: string): JwtPayload | null {
  //   try {
  //     //console.log(jwtDecode<JwtPayload>(token));
  //     return jwtDecode<JwtPayload>(token);
  //   } catch (e) {
  //     console.error("Invalid token:", e);
  //     return null;
  //   }
  // }

  const { state } = useLocation();
  // const history = useNavigate();
  const { TextArea } = Input;
  const [form] = Form.useForm();

  const [manter, setManter] = useState(-1); // -1: Estado neutro. Somente para iniciar / 0 : Em consulta / 1 : Inserir / 2 : Detalhar / 3 : Alterar;
  const [dadosPessoaJuridica, setDadosPessoaJuridica] = useState<IPessoaJuridica>();
  const [tipoIdentificador, setTipoIdentificador] = useState<number>(1);
  // const [modalSucessoAberto, setModalSucessoAberto] = useState(false);
  // const [modalJaExisteAberto, setModalJaExisteAberto] = useState(false);

  const [listaNaturezasJuridicas, setListaNaturezasJuridicas] = useState<ISelectList[]>([]);
  const [listaPaises, setListaPaises] = useState<ISelectList[]>([]);
  const [listaUf, setListaUf] = useState<ISelectList[]>([]);
  const [listaMunicipios, setListaMunicipios] = useState<ISelectList[]>([]);
  const [codPais, setCodPais] = useState(76); // BRASIL
  const [cepLocalizado, setCepLocalizado] = useState(false);

  const [codNaturezaJuridica, setCodNaturezaJuridica] = useState(0);
  const [razaoSocial, setRazaoSocial] = useState("");
  const [cnaePrincipal, setCnaePrincipal] = useState("");

  const [erroApi, setErroApi] = useState<IErroApi>();
  const [estadoErroApi, setEstadoErroApi] = useState(0);
  const [msgErroApi, setMsgErroApi] = useState("");

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  // Função genérica para mostrar uma mensagem na tela.
  function mostrarInfo(title: string, msg: string) {
    info({
      title: title,
      width: "400px",
      icon: <EyeOutlined />,
      content: msg,
    });
  }

  useEffect(() => {
    setLoading(true);
    const carregaDadosIniciais = async () => {
      carregaListaPaisesOpcoes();
      carregaListaNaturezasJuridicasOpcoes();
      carregaListaUFOpcoes();
    }
    carregaDadosIniciais();
    setManter(state.manter);
    setDadosPessoaJuridicaFull(state.data);
    setLoading(false);

    // if(token) decodeToken(token);

    // // PREVINE SAIDA DA PÁGINA COM DADOS EM EDIÇÃO
    // handlerRef.current = (e: BeforeUnloadEvent) => {
    //   e.preventDefault();
    //   e.returnValue = ''; // Still required in most browsers
    // };

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (listaNaturezasJuridicas && listaNaturezasJuridicas.length > 0) {
      form.setFieldsValue({
        nmNaturezaJuridica: listaNaturezasJuridicas.find(x => x.value === codNaturezaJuridica),
      });
    }
  }, [listaNaturezasJuridicas]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (manter === 2 && dadosPessoaJuridica) { // SE OS DADOS DE PESSOA FÍSICA JÁ ESTIVEREM PREENCHIDO EXIBIR DETALHES - ESTA AÇÃO DECORRE NORMALMENTE QUANDO SE CANCELA A EDIÇÃO
      setDadosPessoaJuridicaFull(dadosPessoaJuridica);
    }

  }, [manter]); // eslint-disable-line react-hooks/exhaustive-deps  

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi]); // eslint-disable-line react-hooks/exhaustive-deps

  function setDadosPessoaJuridicaFull(pj: IPessoaJuridica) {
    setTipoIdentificador(pj.tipoIdentificador);
    setCodNaturezaJuridica(pj.naturezaJuridica);
    setRazaoSocial(pj.razaoSocial);
    setCnaePrincipal(pj?.numeroCnae || "");
    if (pj.pais)
      setCodPais(pj.pais);
    else
      if (pj.tipoIdentificador && (pj.tipoIdentificador === 1 || pj.tipoIdentificador === 3))
        setCodPais(76); // BRASIL
      else 
        setCodPais(0);

    form.setFieldsValue({
      cnpjNumero: pj.tipoIdentificador === 1 ? maskCnpj(pj.numero) : undefined,
      numeroIdentificacaoFiscal: pj.tipoIdentificador === 2 ? pj.numero : undefined,
      numeroProcesso: pj.numeroProcesso ? maskNumeroProcesso(pj.numeroProcesso) : undefined,
      nomeFantasia: pj.nomeFantasia,
      razaoSocial: pj.razaoSocial,

      atividadeEconomica: pj.numeroCnae,

      situacaoCadastral: pj.situacaoCadastral,
      dataSituacaoCadastral: pj.dataSituacaoCadastral ? dayjs(pj.dataSituacaoCadastral) : undefined,

      cep: pj.cep,
      logradouro: pj.logradouro,
      numeroEndereco: pj.numeroEndereco,
      nmPais: pj.nomePais ? pj.nomePais.toUpperCase() : "",
      siglaUf: pj.siglaUf,
      nomeCidade: pj.nomeCidade,
      bairro: pj.bairro,
      complemento: pj.complemento,
      telefone1: pj.telefone1 ? maskTelefone(pj.telefone1) : undefined,
      telefone2: pj.telefone2 ? maskTelefone(pj.telefone2) : undefined,
      email: pj.email,
      emailInstitucional: pj.emailInstitucional,
      site: pj.site,
      observacao: pj.observacao,
    });


    setDadosPessoaJuridica(pj); // RECUPERA OS DADOS DIRETO DA BASE. ESTA ARRAY MANTÉM INTACTO OS DADOS RECEBIDOS DA BASE, QUE PODERÃO SER UTILIZADOS PARA RECUPERAR INFORMAÇÕES EM CASO DE CANCELAMENTO DE EDIÇÃO.
    // No caso de registro histórico, os demais valores de statusReg também aparecem. Por isso, filtra-se somente statusReg === 1
  }

  const handleProcessoBlur = (processo: string) => {
    form.setFieldsValue({
      numeroProcesso: maskNumeroProcesso(processo)
    })
  }

  const validarPessoaJuridica = () => {
    const { cnpjNumero, numeroIdentificacaoFiscal } = form.getFieldsValue();

    if (!cnpjNumero && !numeroIdentificacaoFiscal) {
      errorMessage("CNPJ e Número de Identificação Fiscal não podem ser ambos vazios.");
      return;
    }

    if (cnpjNumero && numeroIdentificacaoFiscal) {
      errorMessage("CNPJ e Número de Identificação Fiscal não podem ser ambos preenchidos.");
      return;
    }

    if (!cnpjNumero && !numeroIdentificacaoFiscal) {
      errorMessage("Um dos dois campos deve ser preenchido: CNPJ ou Número de Identificação Fiscal.");
      return;
    }

    form
      .validateFields()
      .then(() => {
        sendForm();
      })
      .catch((_error) => {
        errorMessage("Campo obrigatório não preechido");
      });

  };

  const sendForm = async () => {
    setLoading(true);
    const currentForm = form.getFieldsValue();
    //console.log(currentForm)
    const numero = tipoIdentificador === 1 ? numberOnly(currentForm?.cnpjNumero) : numberOnly(currentForm?.numeroIdentificacaoFiscal)

    if (!numero || numero === "") {
      errorMessage("CNPJ e ID não podem ser ambos vazios.");
      return null;
    }
    const json: IPessoaJuridica = {
      numero: numero,
      serie: undefined,
      nomeFantasia: currentForm?.nomeFantasia,
      razaoSocial: currentForm?.razaoSocial,
      numeroCnae: cnaePrincipal !== "" ? cnaePrincipal : undefined,
      //validada: data.validada,
      observacao: currentForm?.observacao,
      naturezaJuridica: codNaturezaJuridica,
      numeroProcesso: numberOnly(
        currentForm?.numeroProcesso === "" ? "" : currentForm?.numeroProcesso
      ),
      cep: numberOnly(currentForm?.cep),
      // tipoLogradouro: cadastro?.tipoLogradouro,
      logradouro: currentForm?.logradouro,
      numeroEndereco: currentForm?.numeroEndereco,
      complemento: currentForm?.complemento,
      bairro: currentForm?.bairro,
      siglaUf: currentForm?.siglaUf,
      telefone1: numberOnly(currentForm?.telefone1),
      telefone2: numberOnly(currentForm?.telefone2),
      nomePais: currentForm?.nmPais,
      pais: codPais,
      site: currentForm?.site,
      email: currentForm?.email,
      emailInstitucional: currentForm?.emailInstitucional,
      nomeCidade: currentForm?.nomeCidade,
      tipoIdentificador: tipoIdentificador,
    };

    //console.log("json subindo");
    //console.log(json);

    try {
      const { data } = await api.post(`/versionar/${json.numero}/numero`, json);
      setLoading(false);
      setDadosPessoaJuridica(data);
      successMessage(
        `Pessoa Jurídica "${currentForm?.razaoSocial}" versionada com Sucesso`
      );
      setManter(2);
    } catch (error: any) {
      setLoading(false);
      if (error.response) {
        errorMessage(`${error.response.data.mensagem}`);
        if (error.response.data.campos) {
          error.response.data.campos.map((c: any) => {
            errorMessage(`${c.cmensagem}`);
          });
        }
      }
      // Return comentado pq esta retornando essa mensagem de erro por default para todos os erros de cadastro
      // return errorMessage("Ocorreu um erro ao tentar realizar uma operação");
    }

  };

  const resetForm = () => {
    setLoading(true);
    form.resetFields();
    setTipoIdentificador(0);
    setCodNaturezaJuridica(0);
    setCodPais(76); // VOLTA AO PADRÃO (BRASIL)
    setDadosPessoaJuridica(undefined);
    setLoading(false);
  };


  // // Add/remove event listener based on `isDirty`
  // useEffect(() => {
  //   const handler = handlerRef.current!;
  //   if (isDirty) {
  //     window.addEventListener('beforeunload', handler);
  //   } else {
  //     window.removeEventListener('beforeunload', handler);
  //   }

  //   // Cleanup when component unmounts
  //   return () => {
  //     window.removeEventListener('beforeunload', handler);
  //   };
  // }, [isDirty]);

  const carregaListaNaturezasJuridicasOpcoes = async () => {
    let listaLocal: any = [];
    //    await carregaListaNaturezasJuridicas().then((response) => {
    await carregaListaNaturezasJuridicasIbge().then((response) => {
      response.data.forEach((p: any) => {
        // listaLocal.push({ value: p.codigo, label: p.descricao });
        listaLocal.push({ value: p.codNaturezaJuridica, label: (p.codNaturezaJuridica + " - " + p.descNaturezaJuridica.toUpperCase()) });
      })
    });
    setListaNaturezasJuridicas(listaLocal);
  }

  const carregaCnpjEPreencheDados = async () => {
    if (dadosPessoaJuridica && dadosPessoaJuridica?.numero !== "") {

      return consultaCNPJReceita(numberOnly(dadosPessoaJuridica.numero)).then(async (resposta) => {

        setCodNaturezaJuridica(resposta.data.naturezaJuridica?.codigo);
        setRazaoSocial(resposta.data.nomeEmpresarial);
        setCnaePrincipal(resposta.data.cnaePrincipal?.codigo);

        form.setFieldsValue({
          cnpjNumero: maskCnpj(resposta.data.ni),
          atividadeEconomica: resposta.data.cnaePrincipal?.codigo + " - " + resposta.data.cnaePrincipal?.descricao,
          nmNaturezaJuridica: listaNaturezasJuridicas.find(x => x.value === resposta.data.naturezaJuridica?.codigo),
          nomeFantasia: resposta.data.nomeFantasia,
          razaoSocial: resposta.data.nomeEmpresarial,
          dataAbertura: resposta.data.dataAbertura ? dayjs(resposta.data.dataAbertura) : undefined,
          situacaoCadastral: resposta.data.situacaoCadastral?.codigo,
          dataSituacaoCadastral: resposta.data.situacaoCadastral?.data ? dayjs(resposta.data.situacaoCadastral?.data) : undefined,
          nmPais: resposta.data.endereco.pais.descricao.toUpperCase(),
          cep: maskCep(resposta.data.endereco.cep),
          numeroEndereco: resposta.data.endereco.numero,
          telefone1: resposta.data.telefones && resposta.data.telefones[0]?.ddd ? maskTelefone(resposta.data.telefones[0].ddd + resposta.data.telefones[0].numero) : dadosPessoaJuridica?.telefone1,
          telefone2: resposta.data.telefones && resposta.data.telefones[1]?.ddd ? maskTelefone(resposta.data.telefones[1].ddd + resposta.data.telefones[1].numero) : dadosPessoaJuridica?.telefone2
        });
        await carregaCepEPreencheEndereco(resposta.data.endereco.cep);
      });
    }
  };


  const carregaCepEPreencheEndereco = async (cep: string) => {
    setTipLoading("Buscando CEP");
    setLoading(true);
    return carregaCEP(cep).then((responseCep) => {
      setCepLocalizado(true);
      let estado = listaUf.find(u => u.label === responseCep.data.uf);
      carregaListaMunicipios(estado?.value).then((responseMun) => {
        let l = responseMun.data.map((m: { id: any; nome: any; }) => {
          return { value: m.id, label: m.nome }
        });
        setListaMunicipios(l);
        let munic = l.find((m: { label: string; }) => m.label.toUpperCase() === responseCep.data.cidade.toUpperCase());
        form.setFieldsValue({
          nomeCidade: munic.value,
        });
      });
      form.setFieldsValue({
        siglaUf: listaUf.find(u => u.label === responseCep.data.uf)?.value,
        bairro: responseCep.data.bairro,
        logradouro: responseCep.data.endereco,
        complemento: responseCep.data.complemento,
      });
      setTipLoading("");
      setLoading(false);

    })
      .catch(err => {
        setCepLocalizado(false);
        let data: any = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        //        setEstadoErroApi(err.response.status);
        //        setMsgErroApi(msgErro + msgDetalheErro);
        // if (err.response.status < 500) {
        //   setErroApi(data);
        // } else {
        //   errorMessage(msgErro);
        // }
        errorMessage(msgErro);
        setLoading(false);
      });
  };

  const carregaListaPaisesOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaPaises().then((response) => {
      response.data.forEach((p: any) => {
        // if (p.id['M49'] !== 76) {  // BRASIL
        //   listaLocal.push({ value: p.id['M49'], label: p.nome });
        // }
        listaLocal.push({ value: p.id['M49'], label: p.nome.toUpperCase() });
      });
    });

    const sortedList = [...listaLocal].sort((a, b) =>
      a.label.localeCompare(b.label)
    );

    // Coloca o Brasil no tipo da lista
    const brasilItem = sortedList.find(x => x.value === 76);
    const newList = [brasilItem, ...sortedList.filter(x => x.value !== 76)];
    setListaPaises(newList);
  }

  const carregaListaUFOpcoes = async () => {
    let listaLocal: any = [];
    await carregaListaUF().then((response) => {
      response.data.forEach((p: any) => {
        listaLocal.push({ value: p.id, label: p.sigla })
      });
    });
    setListaUf(listaLocal);
  }

  const handleNaturezaJuridica = async (naturezaJuridica: any) => {

    form.setFieldsValue({
      nmNaturezaJuridica: naturezaJuridica.label,
    });

    setCodNaturezaJuridica(naturezaJuridica.value);
  };

  const handlePais = async (pais: any) => {
    form.setFieldsValue({
      nmPais: pais.label,
    });

    setCodPais(pais.value);

    if (pais.value !== 76) { // BRASIL
      form.setFieldsValue({
        siglaUf: undefined,
        nomeCidade: undefined,
      });
    }
  };


  return (
    <Spin spinning={loading} tip={tipLoading}>

      {/* <Modal title="Já existe" open={modalJaExisteAberto} onOk={handleOkJaExiste}
        onCancel={handleCancelJaExiste}>
        <p>A Pessoa jurídica já está cadastrada no sistema.</p>
      </Modal>
      <Modal title="Sucesso" open={modalSucessoAberto} onOk={handleOkSucesso}
        onCancel={handleCancelSucesso} cancelButtonProps={{ disabled: true }}>
        <p>A Pessoa jurídica foi cadastrada com sucesso.</p>
      </Modal> */}

      <Form layout='vertical' style={{ padding: 24 }} onFinish={validarPessoaJuridica} scrollToFirstError form={form} >
        <div className="main-content pl-sm-3 mt-4">
          <h1>{
            (() => {
              switch (manter) {
                case 1:
                  return "Cadastrar Pessoa Jurídica"
                case 2:
                  return "Detalhar Pessoa Jurídica"
                case 3:
                  return "Versionar Pessoa Jurídica"
                default:
                  return null
              }
            })()}
          </h1>
        </div>

        <Card>
          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Básicas</h2>
          </div>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label='CNPJ'
                name='cnpjNumero'
              >
                <Input maxLength={18}
                  disabled={true}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={2}>
              <Tooltip title='Atualizar dados da Pessoa Jurídica'>
                <Button
                  shape='round' type='primary' icon={<SearchOutlined />}
                  disabled={manter === 2 || tipoIdentificador === 2 ? true : false}
                  style={{ marginTop: "30px", marginLeft: "3px" }}
                  onClick={() => {
                    if (dadosPessoaJuridica)
                      carregaCnpjEPreencheDados()
                  }}
                />
              </Tooltip>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Número de Identificação Fiscal (NIF)'
                name='numeroIdentificacaoFiscal'
              >
                <Input
                  maxLength={21}
                  disabled={true}
                />

              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Número do Processo'
                name='numeroProcesso'
                rules={[
                  {
                    required: tipoIdentificador === 2,
                    message: "Número do processo é Obrigatório para NIF",
                  },
                ]}
              >
                <Input
                  disabled={manter === 2 ? true : false}
                  maxLength={21}
                  onChange={(e) =>
                    form.setFieldsValue({
                      numeroProcesso: maskNumeroProcesso(e.target.value),
                    })
                  }
                  onBlur={(e) =>
                    handleProcessoBlur(e.target.value)
                  }
                />

              </Form.Item>
            </Col>

          </Row>
          <Row>
            <Col xs={24} xl={15}>
              <Form.Item
                label='Nome Empresarial'
                name='razaoSocial'
                rules={[
                  {
                    required: true,
                    message: "Razão Social é Obrigatório",
                  },
                ]}
              >
                <Input maxLength={100}
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  onBlur={(e) =>
                    setRazaoSocial(e.target.value)
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Nome Fantasia'
                name='nomeFantasia'
                rules={[
                  {
                    required: true,
                    message: "Nome Fantasia não preenchido",
                  },
                ]}
              >
                <Input maxLength={100}
                  disabled={manter === 2 ? true : false}
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações da Receita Federal</h2>
          </div>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Natureza Jurídica'
                name='nmNaturezaJuridica'
                rules={[
                  {
                    required: true,
                    message: "Natureza Jurídica é Obrigatório"
                  },]} >
                <Select
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  showSearch filterOption optionFilterProp='children'
                  placeholder='SELECIONE UMA NATUREZA JURÍDICA'
                  options={listaNaturezasJuridicas}
                  onChange={(_, index) => {
                    handleNaturezaJuridica(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={12}>
              <Form.Item
                label='Atividade Econômica Principal'
                name='atividadeEconomica'>
                <Input maxLength={100}
                  disabled={true}
                  style={{ backgroundColor: color.nomeFantasiaColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Data de Abertura'
                name='dataAbertura' >
                <DatePicker
                  // disabled={tipoIdentificador === 1}
                  disabled={true}
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Selecionar Data"
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Situação Cadastral'
                name='situacaoCadastral'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Data Situação Cadastral'
                name='dataSituacaoCadastral' >
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
            <Col xs={24} xl={6}>
              <Form.Item
                label='Motivo da Situação Cadastral'
                name='motivoSituacao'>
                <Input disabled maxLength={20} />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Endereço</h2>
          </div>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label='CEP'
                name='cep'
                rules={[{
                  required: true,
                  message: "CEP obrigatório não preenchido",
                },]}
              >

                <Input maxLength={10}
                  onChange={(e) =>
                    form.setFieldsValue({
                      cep: maskCep(e.target.value),
                    })
                  }
                  // onBlur={(e) =>
                  //   carregaCepEPreencheEndereco(e.target.value)
                  // }
                  style={{ width: "100%", backgroundColor: color.cepColor }}
                  disabled={manter === 2 || tipoIdentificador === 1 && cepLocalizado ? true : false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12} xl={2}>
              <Tooltip title='Buscar CEP'>
                <Button
                  shape='round' type='primary' icon={<SearchOutlined />}
                  disabled={manter === 2 || tipoIdentificador <= 2 && cepLocalizado ? true : false}
                  style={{ marginTop: "30px", marginLeft: "3px" }}
                  onClick={() => {
                    if (dadosPessoaJuridica)
                      carregaCepEPreencheEndereco(form.getFieldValue('cep'))
                  }} >
                  {/* Buscar CEP */}
                </Button>
              </Tooltip>
            </Col>

            <Col xs={24} xl={11}>
              <Form.Item
                label='Logradouro'
                name='logradouro'
                rules={[{
                  required: true,
                  message: "Endereco obrigatório não preenchido",
                },]}
              >
                <Input maxLength={100}
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  style={{ backgroundColor: color.enderecoColor }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={5}>
              <Form.Item
                label='Número'
                name='numeroEndereco' rules={[{
                  required: tipoIdentificador !== 1,
                  message: "Número obrigatório não preenchido",
                },]}>
                <Input
                  maxLength={10}
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  style={{ backgroundColor: color.numeroColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={5}>
              <Form.Item
                label='País'
                name='nmPais'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}
              >
                <Select showSearch filterOption optionFilterProp='children'
                  placeholder='País'
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  options={listaPaises}
                  onChange={(_, index) => {
                    handlePais(index);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={4}>
              <Form.Item
                label='UF'
                name='siglaUf'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Estados'
                    className={color.ufColor === "#ffdada" ? "input" : ""}
                    disabled={manter === 2 ? true : false}
                    onChange={(e) => {
                      carregaListaMunicipios(e.value).then((response) => {
                        setListaMunicipios(response.data);
                      });
                    }
                    }
                    options={listaUf}
                  />
                ) : (
                  <Input
                    maxLength={100}
                    disabled={manter === 2 ? true : false}
                  />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={7}>
              <Form.Item
                label='Município'
                name='nomeCidade'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                {codPais === 76 ? (
                  <Select showSearch filterOption optionFilterProp='children' placeholder='Município'
                    className={
                      color.municipioColor === "#ffdada" ? "input" : ""
                    }
                    disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                    options={listaMunicipios}
                  />
                ) : (
                  <Input
                    maxLength={100}
                    disabled={manter === 2 ? true : false}
                  />
                )}
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Bairro'
                name='bairro'
              >
                <Input maxLength={60}
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  style={{ backgroundColor: color.bairroColor }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={12}>
              <Form.Item
                label='Complemento'
                name='complemento'>
                <Input
                  maxLength={30}
                  disabled={manter === 2 || tipoIdentificador === 1 ? true : false}
                  style={{ backgroundColor: color.complementoColor }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 1'
                name='telefone1'
                rules={[{
                  required: true,
                  message: "Campo obrigatório não preenchido",
                },]}>
                <Input maxLength={15}
                  onChange={(e) =>
                    form.setFieldsValue({
                      telefone1: maskTelefone(e.target.value),
                    })
                  }
                  style={{
                    width: "100%",
                    backgroundColor: color.telefone1Color,
                  }}
                  disabled={manter === 2 ? true : false}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={6}>
              <Form.Item
                label='Telefone 2'
                name='telefone2'>
                <Input maxLength={15}
                  onChange={(e) =>
                    form.setFieldsValue({
                      telefone2: maskTelefone(e.target.value),
                    })
                  }
                  style={{ width: "100%" }}
                  disabled={manter === 2 ? true : false}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail'
                name='email'
                rules={[
                  {
                    required: true,
                    message: "Digite um email válido",
                    type: "email",
                  },
                ]}
              >
                <Input
                  maxLength={100}
                  disabled={manter === 2 ? true : false}
                  style={{
                    textTransform: "lowercase",
                    backgroundColor: color.emailColor,
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='E-mail Comunicação PREVIC'
                name='emailInstitucional'
                rules={[
                  {
                    message: "Digite um email válido",
                    type: "email",
                  },
                ]} >
                <Input
                  maxLength={100}
                  disabled={manter === 2 ? true : false}
                  style={{ textTransform: "lowercase" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} xl={8}>
              <Form.Item
                label='Site'
                name='site'>
                <Input className='lowercase'
                  maxLength={100}
                  disabled={manter === 2 ? true : false}
                  addonBefore={(
                    <Select
                      disabled={manter === 2 ? true : false}
                      defaultValue='https://'
                      className='select-before lowercase' options={[
                        { value: 'http://', label: 'http://' },
                        { value: 'https://', label: 'https://' }
                      ]}
                    >
                    </Select>
                  )}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Informações Complementares</h2>
          </div>

          <Row>
            <Col span={24}>
              <Form.Item
                label='Observações'
                name='observacao'>
                <TextArea
                  disabled={manter === 2 ? true : false}
                  maxLength={300}
                  showCount={true}
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  onChange={(e) =>
                    form.setFieldsValue({
                      observacao: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* <Row justify="end">
            <Space align='center' >
              {
                <>
                  <Button shape='round' type='primary' icon={<CheckOutlined />} htmlType='button'
                    onClick={() => {
                      resetColor();
                      mostrarConfirmar();
                    }} >
                    Salvar
                  </Button>
                  <Button disabled={false} shape='round' icon={<ClearOutlined />} htmlType='button'
                    onClick={() => {
                      resetForm();
                      resetColor();
                      window.scrollTo(0, 0)
                    }} >
                    Cancelar
                  </Button>
                </>
              }
            </Space>
          </Row> */}
        </Card>

        <CadInfoBotoes
          resetForm={resetForm}
          detalhar={false}
          form={form}
          // desabilitaBtnEditar={desabilitaBtnEditar}
          resetColor={resetColor}
          manter={manter}
          setManter={setManter}
          msgConfirmacao={razaoSocial}
          rotaConsultar={"/" + import.meta.env.VITE_APP_BASE + "/pessoa-juridica-consultar"}
        />

      </Form>

    </Spin>
  );
};

export default Manter;

